module.exports = __webpack_public_path__ + "static/10-59951ab51b31f08e3e4968282b5b954e.jpeg";